import ReactDOM from 'react-dom';
import { decode } from '@finn-no/safe-props';
import { DecodedDataset } from 'types';
import App from 'App';
import WebComponentPortal from 'WebComponentPortal';

const root = document?.getElementById('tjt-podlet-shippable');

if (root) {
    const encodedDataset = root?.dataset.props ?? '';
    const props: DecodedDataset = decode(encodedDataset);
    ReactDOM.render(
        <WebComponentPortal containerElement={root}>
            <link
                href={props.styleLink}
                media="all"
                type="text/css"
                rel="stylesheet"
            />
            <App finnkode={props.finnkode} sections={props.sections} />
        </WebComponentPortal>,
        root,
    );
}
